module.exports = __webpack_public_path__ + "aa.no1.a953ed70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/aa.no1.jpg
// module id = lr5X
// module chunks = 0